"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toString = {}.toString;
var isType = function (value, type) { return toString.call(value) === '[object ' + type + ']'; };
exports.default = isType;
//# sourceMappingURL=is-type.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-type.js
// module id = 112
// module chunks = 37